
export class LoginAutomatico {
    cpf: string;
    dataNascimento: string;
    funcionalidade?: string;
    contrato?: string;

    static parseBase64(loginAutomaticoBase64?: string): LoginAutomatico | null {
        try {
            if (loginAutomaticoBase64) {
                return JSON.parse(atob(loginAutomaticoBase64)) as LoginAutomatico;
            }
        } catch (error) {
            console.error('Erro ao parcear informações do login autimático.');
        }

        return null;
    }
}
